type PathFunction = {
  (): string
  (segment: string): PathFunction
}

export const modelName = (initial: string): PathFunction => {
  const createPathFunction = (currentPath: string): PathFunction => {
    const pathFunc = function (segment?: string): string | PathFunction {
      if (segment === undefined) {
        return currentPath
      }

      return segment ? createPathFunction(`${currentPath}/${segment}`) : currentPath
    }

    return <PathFunction>pathFunc
  }

  return createPathFunction(initial)
}
